import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Flex, Text } from '@chakra-ui/react';
import { formatCentsAsDollars } from '@heirloom/common/utils/priceDisplay';
export const PriceTag = (props) => {
    return (_jsx(Flex, { position: "relative", borderRadius: 5, bg: "brand", color: "#FFFFFF", style: {
            clipPath: 'polygon(0 50%, 10px 100%, 100% 100%, 100% 0, 10px 0)',
        }, _after: {
            content: '""',
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            width: '6px',
            height: '6px',
            bg: '#FFFFFF',
            borderRadius: 'full',
        }, children: _jsxs(Text, { fontSize: 22, fontWeight: 500, paddingLeft: 6, paddingRight: 3, paddingTop: 0.5, paddingBottom: 1, children: [formatCentsAsDollars(props.priceCents), props.isMinimum && '+', props.quantity &&
                    props.quantity > 1 &&
                    ` (${props.quantity})`] }) }));
};
